import {BaseModel} from "./base-model";

// TODO remove class: production line = field service
export class ProductionLine extends BaseModel {

  protected static self = ProductionLine;

  public validate(): boolean {
    return true;
  }
}
